@if (!isHidden()) {
    <div class="container-menu-options">

        <section-item 
            [icon]="'edit-2'" 
            [text]="'common.edit' | translate" 
            (click)="edit.emit(); close.emit();"
        />

        <section-item 
            [icon]="'trash'" 
            [text]="'common.delete' | translate" 
            [type]="'danger'" 
            (click)="remove.emit(); close.emit();"
        />
    </div>
}
